import script from "./Step3PagoBoleto.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3PagoBoleto.vue?vue&type=script&setup=true&lang=js"

import "./Step3PagoBoleto.vue?vue&type=style&index=0&id=30f3556a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30f3556a"]])

export default __exports__